import request from 'api/index'

export const updateUserNoticeDismissApi = (noticeId: number) =>
  request<CommonResponse>({
    method: 'put',
    path: `/api/user-notice/v1/${noticeId}/dismiss`,
  })
